import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import '../../style/navigation.css';

function Navigation() {
    // 顶部菜单数据
    const menuList = [
        {
            id: 'S-Y',
            name: '首页'
        },
        {
            id: 'C-Y-B-J',
            name: '产业布局'
        },
        {
            id: 'C-Y-Z-C',
            name: '各类政策'
        }
    ]
    // 选中数据
    const [cid, setCid] = useState('S-Y');

    // 滚动方法
    const scorollToPos = (id) => {
        switch (id) {
            case 'S-Y':
                window.scrollTo(0, 0);
                break;
            case 'C-Y-B-J':
                window.scrollTo(0, 690);
                break;
            case 'C-Y-Z-C':
                window.scrollTo(0, 10000);
                break;
            default:
                break;
        }
    }

    // 手机端拨打电话
    const callPhone = (number) => {
        window.location.href = `tel://${number}`;
    }

    useEffect(() => {

        // 监听滚动事件并更新scrollY状态
        const handleScroll = () => {
            if (window.scrollY <= 600) {
                setCid('S-Y');
            }
            if (window.scrollY > 600) {
                setCid('C-Y-B-J');
            }
            if (window.scrollY > 1200) {
                setCid('C-Y-Z-C');
            }
        };
        // 添加滚动事件监听器
        window.addEventListener('scroll', handleScroll);
        // 清除事件监听器以防止内存泄漏
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };

    }, []);

    return (
        <div className="navigation">
            <div className="menu">
                {
                    menuList.map((item) => (
                        <div
                            className={`menu-item ${cid === item.id ? 'active' : ''}`}
                            key={item.id}
                            onClick={() => {
                                setCid(item.id)
                                scorollToPos(item.id)
                            }}>
                            <Link to='/'>
                                {item.name}
                            </Link>
                        </div>
                    ))
                }
                <div className="menu-item nav-contact">
                    <div className="right-hover-phone">
                        <div className="right-hover-back"></div>
                        <img className="hover-icon" src="http://www.hsfdr.com/mstyle/themes/img/phone_hover@2x.png" alt="" />
                        <div className="phone-font" onClick={() => callPhone('0898-88913566')}>0898-88913566</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Navigation;
